<template>
    <transition name="modal" v-if="isActive">
        <perfect-scrollbar class="modal-mask">
            <div class="modal-stock-list modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>
                            <b-icon icon="pencil-square"></b-icon>
                            <span>จัดการสต๊อค</span>
                        </h4>

                        <button class="btn-close" @click="hide()"><b-icon icon="x"></b-icon></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="product-data">
                                    <img :src="contentData.productData.brandLogo" class="brand" v-if="contentData.productData.brandLogo" />
                                    <h2>{{ contentData.productData.name }}</h2>
                                    <span v-if="contentData.productData.size">ขนาด {{ contentData.productData.size }}</span>
                                </div>

                                <!-- Stock Adjusting Form Start -->
                                <inventory-modal-adjust-stock v-if="!isShowStockDot"
                                    :contentData="contentData"
                                    :fixSupplier="fixSupplier"
                                    @stockUpdate="stockUpdate($event)">
                                </inventory-modal-adjust-stock>
                                <!-- Stock Adjusting Form End -->

                                <div class="mt-3" v-if="contentData.productData.productCategory === $Constants.CATEGORY_TIRE">
                                    <button class="btn btn-grey-outline btn-block" @click="displayStockDot()">{{ isShowStockDot ? 'ปิดรายการสัปดาห์ยาง' : 'ดูรายการสัปดาห์ยาง' }}</button>
                                </div>

                                <!-- Stock Dot Form Start -->
                                <inventory-modal-dot-table v-if="isShowStockDot"
                                    :contentData="contentData"
                                    @stockUpdate="stockUpdate($event)">
                                </inventory-modal-dot-table>
                                <!-- Stock Dot Form End -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </perfect-scrollbar>
    </transition>
</template>

<script>
import InventoryModalAdjustStock from '@/components/inventory/modalStock/AdjustStock';
import InventoryModalDotTable from '@/components/inventory/modalStock/DotTable';

export default {
    components: {
        InventoryModalAdjustStock,
        InventoryModalDotTable
    },
    data() {
        return {
            isActive: false,
            isShowStockDot: false
        };
    },
    props: {
        isDisplay: Boolean,
        contentData: Object,
        fixSupplier: String
    },
    watch: {
        isDisplay(value) {
            this.isActive = value;
            this.$root.$emit('rootSetContentScrollable', !value);
            
            if (value) {
                this.isShowStockDot = false;
            }
        }
    },
    methods: {
        hide() {
            this.$emit('hide', null);
        },
        stockUpdate(data) {
            this.$emit('stockUpdate', data);
        },
        displayStockDot() {
            this.isShowStockDot = !this.isShowStockDot;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/components/inventory/modalStock/StockContent.scss';
</style>